<mat-sidenav-container autosize class="main-sidenav page-{{ currentMenu?.module }}"
  [ngClass]="{ opened: sideNavState }">
  <mat-sidenav #sidenav *ngIf="(isLoggedIn$ | async) && currentModule !== ''" [mode]="!isMobile ? 'side' : 'over'"
    [opened]="!isMobile">
    <div class="logo-container" [ngClass]="{ small: !sideNavState }">
      <div [ngClass]="{ small_icon: !sideNavState, logo_container_content: sideNavState}">
        <a id="menu_home" [routerLink]="['/']">
          <img src="../../../../assets/logo_dad_horizontal.png" alt="logoDaD" height="50" class="img-logo" />
        </a>
        <span class="version">v.{{version}}</span>
      </div>
    </div>
    <mat-divider></mat-divider>
    <mat-accordion>
      <mat-expansion-panel *ngFor="let menu of menuList" [hideToggle]="!menu.subMenuList"
        [expanded]="'/' + currentModule === menu.link">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <a [id]="'menu_' + menu?.module" [routerLink]="menu.link"
              [ngClass]="{ active: '/' + currentModule === menu.link }" [title]="menu.description" mat-list-item>
              <mat-icon class="menu-icons" *ngIf="menu.icon"> {{ menu.icon }} </mat-icon>
              <mat-icon class="menu-icons" [svgIcon]="menu?.iconSVG" *ngIf="menu.iconSVG"></mat-icon>
              <span *ngIf="sideNavState">
                {{ menu.name }}
              </span>
            </a>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-nav-list *ngIf="menu.subMenuList">
          <div *ngFor="let submenu of menu.subMenuList">

            <a [id]="'submenu_' + submenu?.module" mat-list-item [routerLink]="submenu.link" [title]="submenu.name"
              [ngClass]="{ active: currentMenu?.module === submenu?.module }" *ngIf="!submenu.hidden">
              <mat-icon *ngIf="submenu.icon" style="padding-right: 5px">
                {{ submenu.icon }}
              </mat-icon>
              <mat-icon *ngIf="submenu?.iconSVG" style="padding-right: 5px" [svgIcon]="submenu.iconSVG"></mat-icon>
              <img style="margin-left: 3px" *ngIf="!submenu.icon && !submenu?.iconSVG"
                src="/assets/icon/{{ submenu?.urlIcon || submenu?.module }}.svg" width="20" height="20" />
              <span *ngIf="sideNavState">
                {{ submenu.name }}
              </span>
            </a>
          </div>
        </mat-nav-list>
      </mat-expansion-panel>
    </mat-accordion>
    <button id="sidenav_expanded" mat-button class="sinenav-expanded" [ngClass]="{ opened: sideNavState }"
      (click)="onSinenavToggle()">
      <mat-icon *ngIf="sideNavState">chevron_left</mat-icon>
      <mat-icon *ngIf="!sideNavState">chevron_right</mat-icon>
    </button>
  </mat-sidenav>
  <mat-sidenav-content [ngClass]="{ margin: isLoggedIn$ | async }">
    <button id="sidenav_toggle" mat-button *ngIf="(isLoggedIn$ | async) && currentModule !== ''"
      (click)="sidenav.toggle()" class="sinenav-toggle">
      <mat-icon>menu</mat-icon>
    </button>
    <app-header *ngIf="(isLoggedIn$ | async) && showPage" [title]="currentTitle"
      [version]="currentVersion"></app-header>
    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>

<app-progressbar></app-progressbar>
